var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{staticStyle:{"min-width":"90vw"},attrs:{"persistent":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('v-card',[_c('LoginCard',{attrs:{"showCancelBtn":true},on:{"cancel":_vm.hide}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }